<template>
    <div>
        <v-snackbar v-model="snackbar" :top=true :color="color" :timeout=6000>
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card>
            <v-row justify="center" dense>
                <v-col sm="2"></v-col>
                <v-col sm="4">
                    <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                    <v-combobox dense required v-model="academicyear" :items="ay_list" item-text="ay" item-value="id"
                        label="Academic Year" rounded outlined persistent-hint hint="Please Select Academic Year"
                        @change="getSubject()" />
                </v-col>
                <v-col sm="4">
                    <p><v-icon color="error">*</v-icon><b>Subject</b></p>
                    <v-combobox dense required v-model="subject" :items="subject_list" item-text="subject"
                        item-value="course_off_id" label="Subject" rounded outlined persistent-hint
                        hint="Please Select Subject" />
                </v-col>
                <v-col sm="2"> <v-btn @click="getData()" class="button mt-10 pt-0">Fetch</v-btn></v-col>
            </v-row>
        </v-card>
        <br>
        <v-card v-if="this.learner_leave_application_list != ''">
            <v-data-table :headers="headers" :items="learner_leave_application_list" :search="search"
                class="elevation-1">
                <template v-slot:top>
                    <v-toolbar flat color="white">
                        <v-toolbar-title>Leave Application Report List</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                        <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details>
                        </v-text-field>
                    </v-toolbar>
                </template>


            </v-data-table>
        </v-card>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
import axios from "axios";
export default {
    data: () => ({
        overlay: false,
        learner_leave_application_list: [],
        ay_list: [],
        subject_list: [],
        search: '',
        academicyear: '',
        subject: '',
        snackbar_msg: "",
        color: "",
        snackbar: false, basepath: null,
        headers: [
            { text: "Child Name", value: "learner", sortable: true },
            { text: "Reason", value: "reason", sortable: true },
            { text: "Start Date", value: "start_date", sortable: true },
            { text: "End Date", value: "end_date", sortable: true },
            { text: "Application Date", value: "application_date", sortable: true },


        ],
    }),
    mounted() {
        this.onLoad();
        this.basepath = localStorage.getItem("awspath");
    },
    methods: {
        onLoad() {
            axios
                .post("App/getAcademicYear")
                .then((res) => {
                    if (res.data.flag == "YES") {
                        this.ay_list = res.data.ay_list;

                        this.overlay = false;
                    } else {
                        this.showSnackbar("red", res.data.snackbar);
                        sessionStorage.setItem("error-trace", res.data.error_trace);
                    }
                })
                .catch((error) => {
                    this.showSnackbar("#b71c1c", "Something went wrong!!!");
                    this.overlay = false;
                })
                .finally(() => {
                    this.overlay = false;
                });
        },
        getSubject() {
            this.subject = "";
            const data = {
                ay_id: this.academicyear.id,
            };
            this.overlay = true;
            axios
                .post("/Homework/fetch_ay_based_data_for_inst_subject", data)
                .then(res => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.subject_list = res.data.subject_list
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
                    }
                })
                .catch(error => {
                    this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
                    window.console.log(error);
                })
                .finally(() => {
                    'use strict';
                    var overlay = false
                });
        },
        getData() {

            const data = {
                ay_id: this.academicyear.id,
                course_offering_id: this.subject.course_off_id,
            };
            this.overlay = true;
            axios
                .post("/Homework/fetch_ay_sub_data_for", data)
                .then(res => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.learner_leave_application_list = res.data.learner_leave_application_list;
                    }
                    else {
                        this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
                    }
                })
                .catch(error => {
                    this.showSnackbar("#b71c1c", "Something went wrong!"); // show snackbar on error
                    window.console.log(error);
                })
                .finally(() => {
                    'use strict';
                    var overlay = false
                });
        },

        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },
    }
};
</script>